import {
  ROW,
  TEXTBOX,
  VERTICALSPACER,
  STANDARDPRODUCTTABLE,
  ABOUT,
  ABTESTWRAPPER,
  ADVERTISERDISCLOSUREWRAPPER,
  APPROW,
  AUDIOEMBED,
  ARTICLEHEROWRAPPER,
  AUTOINSURANCECLICKTABLEWRAPPER,
  AUTOINSURANCEENTRYPOINTWRAPPER,
  AUTOINSURANCEQUOTESWRAPPER,
  AWARDSBADGEDROPDOWN,
  AWARDSBADGEDROPDOWNV2,
  AWARDSHERO,
  AWARDSHERO2023,
  AWARDS2024BUTTONS,
  AWARDSNAVIGATION,
  AWARDTABLE,
  BAINREFERRALBANNERSC,
  BACKTOTOP,
  BOXTABLE,
  BORDERBANNER,
  BRANDHEADER,
  BRANDEDARTICLECALCULATOR,
  BRANDEDHERO,
  HORIZONTALBANNER,
  BULLETEDLIST,
  C3CHART,
  CALCULATOR,
  CATEGORYTILES,
  CDSPRODUCTTABLE,
  CDSFILTERS,
  CENTEREDHERO,
  CHARTSECTION,
  COLLAPSIBLEPARAGRAPH,
  CREDITCARDTABLE,
  CTABOX,
  DISCLOSURE,
  DIVIDER,
  EDITABLEBULLETEDLIST,
  EDITABLEFLYOUTHEADER,
  EDITABLEFLOW,
  EDITABLEINTERESTCALCULATOR,
  EDITABLELOGOSALAD,
  EDITABLEPANELGROUP,
  EDITABLEPRODUCTTABLE,
  EDITORCONTROL,
  EXPANDINGPRODUCTTABLE,
  FEATUREBAR,
  FEATUREDSTORY,
  FILTERS,
  FLEXCARD,
  FLEXCARDS,
  GLOBALNAV,
  GRID,
  GRIDFORM,
  HEROLANDSCAPEVIDEO,
  HEROVIDEO,
  HOMEINSURANCECLICKTABLEWRAPPER,
  HOMEINSURANCEENTRYPOINTWRAPPER,
  ICONHEADER,
  IMAGE,
  IMAGECONTENT,
  INSURANCEPRODUCTCARDWRAPPER,
  INSURANCESTICKYWIDGET,
  INSURANCESUMMARYTABLEWRAPPER,
  JUMPLINKNAV,
  KETOPRODUCTCARD,
  LABELEDC3CHART,
  LASTCHANCE,
  LASTUPDATE,
  LOTTIEANIMATION,
  LIFEINSURANCEQUOTESWRAPPER,
  MARKETPLACEPRODUCTCARD,
  MARKETPLACETHIRDPARTYEMBED,
  PAGE,
  PARAGRAPH,
  PASSWORDLOCK,
  OURVALUES,
  QUERYPARAMMANAGER,
  QUERYPARAMSECTION,
  RENTERSINSURANCEENTRYPOINTWRAPPER,
  ROWTWOCOL,
  ROWTWOCOLOLD,
  SCREENSIZECONDITIONAL,
  SCROLLCONTROL,
  SPLASH,
  STANDARDHERO,
  STICKYCONTAINERWRAPPER,
  STICKYHEADER,
  STICKYHEADERV2,
  STORY,
  STORYBLOCK,
  STORYCARDS,
  SWEEPSTAKESFORM,
  TERMSTABLE,
  THIRDPARTYEMBED,
  THIRDPARTYEMBEDV2,
  THREESTEPS,
  THREESTEPS2,
  TILECAROUSEL,
  TICKERTAPE,
  TRAVELINSURANCEENTRYPOINTWRAPPER,
  UNIVERSALACCORDION,
  UNIVERSALAUTHBUTTON,
  UNIVERSALBACKGROUNDIMAGE,
  UNIVERSALBUTTON,
  UNIVERSALCONTAINER,
  UNIVERSALMEDIA,
  UNIVERSALIMAGE,
  UNIVERSALPRODUCTTABLE,
  UNIVERSALTEXT,
  VIDEOEMBED,
  ZIGZAG,
  CURRENTDATE,
} from './types';
import { NW_SCHEMAS } from './utils';

/**
 * Schema definitions for landing page client components.
 */
const LPC_SCHEMAS = {
  [ROW]: {
    nodeProps: ['children'],
    version: '1.0.0',
    migrations: {},
  },
  [TEXTBOX]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [VERTICALSPACER]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [STANDARDPRODUCTTABLE]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [ABOUT]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [ABTESTWRAPPER]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [ADVERTISERDISCLOSUREWRAPPER]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [APPROW]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [AUDIOEMBED]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [ARTICLEHEROWRAPPER]: {
    nodeProps: ['children'],
    version: '1.0.0',
    migrations: {},
  },
  [AUTOINSURANCECLICKTABLEWRAPPER]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [AUTOINSURANCEENTRYPOINTWRAPPER]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [AUTOINSURANCEQUOTESWRAPPER]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [AWARDSBADGEDROPDOWN]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [AWARDSBADGEDROPDOWNV2]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [AWARDSHERO]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [AWARDSHERO2023]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [AWARDS2024BUTTONS]: {
    nodeProps: ['children'],
    version: '1.0.0',
    migrations: {},
  },
  [AWARDSNAVIGATION]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [AWARDTABLE]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [BAINREFERRALBANNERSC]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [BACKTOTOP]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [BOXTABLE]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [BORDERBANNER]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [BRANDHEADER]: {
    nodeProps: ['children'],
    version: '1.0.0',
    migrations: {},
  },
  [BRANDEDARTICLECALCULATOR]: {
    nodeProps: ['children'],
    version: '1.0.0',
    migrations: {},
  },
  [BRANDEDHERO]: {
    nodeProps: ['children'],
    version: '1.0.0',
    migrations: {},
  },
  [BULLETEDLIST]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [C3CHART]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [CALCULATOR]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [CATEGORYTILES]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [CDSPRODUCTTABLE]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [CDSFILTERS]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [CENTEREDHERO]: {
    nodeProps: ['children'],
    version: '1.0.0',
    migrations: {},
  },
  [CHARTSECTION]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [COLLAPSIBLEPARAGRAPH]: {
    nodeProps: ['children'],
    version: '1.0.0',
    migrations: {},
  },
  [CREDITCARDTABLE]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [CTABOX]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [DISCLOSURE]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [DIVIDER]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [EDITABLEBULLETEDLIST]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [EDITABLEFLOW]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [EDITABLEINTERESTCALCULATOR]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [EDITABLEFLYOUTHEADER]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [EDITABLELOGOSALAD]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [EDITABLEPANELGROUP]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [EDITABLEPRODUCTTABLE]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [EDITORCONTROL]: {
    nodeProps: ['children'],
    version: '1.0.0',
    migrations: {},
  },
  [EXPANDINGPRODUCTTABLE]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [FEATUREBAR]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [FEATUREDSTORY]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [FILTERS]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [FLEXCARD]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [FLEXCARDS]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [GLOBALNAV]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [GRID]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [GRIDFORM]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [HEROLANDSCAPEVIDEO]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [HEROVIDEO]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [HOMEINSURANCECLICKTABLEWRAPPER]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [HOMEINSURANCEENTRYPOINTWRAPPER]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [HORIZONTALBANNER]: {
    nodeProps: ['children'],
    version: '1.0.0',
    migrations: {},
  },
  [ICONHEADER]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [IMAGE]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [IMAGECONTENT]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [INSURANCEPRODUCTCARDWRAPPER]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [INSURANCESTICKYWIDGET]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [INSURANCESUMMARYTABLEWRAPPER]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [JUMPLINKNAV]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [KETOPRODUCTCARD]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [LABELEDC3CHART]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [LASTCHANCE]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [LASTUPDATE]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [LOTTIEANIMATION]: {
    nodeProps: ['children'],
    version: '1.0.0',
    migrations: {},
  },
  [LIFEINSURANCEQUOTESWRAPPER]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [MARKETPLACEPRODUCTCARD]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [MARKETPLACETHIRDPARTYEMBED]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [PAGE]: {
    nodeProps: ['children'],
    version: '1.0.0',
    migrations: {},
  },
  [PARAGRAPH]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [PASSWORDLOCK]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [QUERYPARAMMANAGER]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [OURVALUES]: {
    nodeProps: ['children'],
    version: '1.0.0',
    migrations: {},
  },
  [QUERYPARAMSECTION]: {
    nodeProps: ['children'],
    version: '1.0.0',
    migrations: {},
  },
  [RENTERSINSURANCEENTRYPOINTWRAPPER]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [ROWTWOCOL]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [ROWTWOCOLOLD]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [SCREENSIZECONDITIONAL]: {
    nodeProps: ['children'],
    version: '1.0.0',
    migrations: {},
  },
  [SCROLLCONTROL]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [SPLASH]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [STANDARDHERO]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [STICKYCONTAINERWRAPPER]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [STICKYHEADER]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [STICKYHEADERV2]: {
    nodeProps: ['children'],
    version: '1.0.0',
    migrations: {},
  },
  [STORY]: {
    nodeProps: ['children'],
    version: '1.0.0',
    migrations: {},
  },
  [STORYBLOCK]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [STORYCARDS]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [SWEEPSTAKESFORM]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [TERMSTABLE]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [THIRDPARTYEMBED]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [THIRDPARTYEMBEDV2]: {
    nodeProps: ['children'],
    version: '1.0.0',
    migrations: {},
  },
  [THREESTEPS]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [THREESTEPS2]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [TILECAROUSEL]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [TICKERTAPE]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [TRAVELINSURANCEENTRYPOINTWRAPPER]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [UNIVERSALACCORDION]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [UNIVERSALAUTHBUTTON]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [UNIVERSALBACKGROUNDIMAGE]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [UNIVERSALBUTTON]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [UNIVERSALCONTAINER]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [UNIVERSALIMAGE]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [UNIVERSALMEDIA]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [UNIVERSALPRODUCTTABLE]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [UNIVERSALTEXT]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [VIDEOEMBED]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [ZIGZAG]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [CURRENTDATE]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
};

/**
 * Include default Structured Content schema so we can interpret documents that contain generic NW components.
 */
export default {
  ...NW_SCHEMAS,
  ...LPC_SCHEMAS,
};
